/* Plan cards + monthly/annual switch (prototype `pricing(inApp)`). */
import { Link } from "react-router-dom";
import type { Cycle } from "../../../data/types";
import { useI18n } from "../../../i18n";
import { Button, Icon, Seg, cx } from "../../../ui";
import { PLANS, PLAN_INFO, perEmployee, type PlanName } from "./pricingData";

export function PricingPlans({ prices, cycle, onCycle, inApp, currentPlan, onChoose }: {
  prices: Record<string, number>;
  cycle: Cycle;
  onCycle: (c: Cycle) => void;
  inApp?: boolean;
  /** Plan of an active subscription (shows a disabled "Current plan" button). */
  currentPlan?: string | null;
  onChoose?: (plan: PlanName) => void;
}) {
  const { t, L } = useI18n();
  return (
    <div data-testid="pricing-plans">
      <div className="row between mb">
        <div>
          {inApp
            ? <span className="sm muted">{L("Prices per employee per month, excluding 15% VAT", "الأسعار لكل موظف شهريًا دون ضريبة 15%")}</span>
            : <span className="chip gold"><Icon name="sparkle" className="s" />{L("30-day free trial on every plan", "تجربة مجانية 30 يومًا لكل الباقات")}</span>}
        </div>
        <Seg label={L("Billing cycle", "دورة الفوترة")} items={[["m", t("Monthly")], ["y", t("Annually") + " · −20%"]]} value={cycle} onChange={onCycle} />
      </div>
      <div className="plans">
        {PLANS.map((p) => {
          const pop = p === "Business";
          const price = perEmployee(prices[p] ?? 0, cycle);
          return (
            <section key={p} className={cx("card", "plan", pop && "pop")} data-testid={"plan-" + p}>
              {pop && <span className="chip pri ribbon">{t("Most popular")}</span>}
              <div>
                <h3 style={{ fontSize: 18 }}>{p}</h3>
                <p className="sm muted" style={{ margin: "4px 0 0" }}>{L(...PLAN_INFO[p].limit)}</p>
              </div>
              <div className="row nw" style={{ alignItems: "baseline", gap: 6 }}>
                <span className="price" data-testid={"plan-price-" + p}>{price}</span>
                <span className="sm muted">{L("SAR", "ر.س")} {t("per employee / month")}</span>
              </div>
              <ul>{PLAN_INFO[p].features.map((f) => <li key={f[0]}><Icon name="check" className="s" /><span>{L(...f)}</span></li>)}</ul>
              {inApp
                ? (currentPlan === p
                  ? <Button className="block" disabled>{t("Current plan")}</Button>
                  : <Button className="block" variant={pop ? "pri" : undefined} onClick={() => onChoose?.(p)} data-testid={"choose-" + p}>{t("Choose plan")}</Button>)
                : <Link className={cx("btn", "block", pop && "pri")} to="/setup" data-testid={"start-" + p}><span>{L("Start 30-day free trial", "ابدأ تجربة 30 يومًا")}</span></Link>}
            </section>
          );
        })}
      </div>
      <p className="xs muted mt">{L("Prices exclude 15% VAT. Billed in SAR. Cancel anytime.", "الأسعار لا تشمل ضريبة القيمة المضافة 15%. الفوترة بالريال. يمكنك الإلغاء في أي وقت.")}</p>
    </div>
  );
}
